/**
 * WEB-1779 — ОДНА ТОЧКА ПРАВДЫ «где лежит подпись кнопки» (решение владельца
 * 03.09, вариант А: чиним чтением, каталог миграцией НЕ трогаем).
 *
 * Почему поле два. Каталог из 25 нишевых шаблонов (миграция-сид
 * `1900000000034-SeedNicheQuizTemplates`) писал авторскую подпись кнопки в
 * `content`: 144 подписи у «Кнопки Далее» и ещё 25 у «Кнопки со ссылкой».
 * Плеер читал только `buttonText` — и все они молча подменялись словом «Далее»
 * (у ссылки — английским 'Learn more'). Правка данных отклонена владельцем
 * (миграция каталога = правка живых воронок клиентов), поэтому второе поле
 * читается плеером.
 *
 * ⚠ Порядок именно такой: `buttonText` СИЛЬНЕЕ. Он — то поле, которое автор
 * правит в панели свойств («Текст кнопки»); `content` у этих типов панель не
 * показывает вовсе (CONTENT_DEAD_BLOCK_TYPES, WEB-1700) и остаётся ЧИТАЕМЫМ
 * ЗАПАСОМ для данных каталога. Значит вид воронки, где `buttonText` заполнен,
 * не меняется ни на пиксель — а это все воронки, собранные в кабинете.
 *
 * ⚠ Пустота считается ровно так же, как её считает `RichTextContent`
 * (`hasRichText`): пустая строка и пустой набор кусков — пусто, что угодно
 * ещё — подпись. Иначе два предиката об одном значении разъехались бы и дали
 * тихую ложь (шрам WEB-1716).
 */
import { asRichField, hasRichText } from '@/types/rich-text';

/** Поля, из которых может прийти подпись кнопки. */
export interface ButtonLabelFields {
  buttonText?: string;
  content?: string;
}

/**
 * Значение, которое рендер отдаёт в `richText(...)` как подпись кнопки.
 * `undefined` — подписи нет ни в одном поле, показывается запас рендера
 * (локализованное «Далее»/«Завершить» у кнопки продвижения, 'Learn more' у
 * кнопки со ссылкой).
 */
export function buttonLabelField(block: ButtonLabelFields): string | undefined {
  if (hasRichText(asRichField(block.buttonText))) return block.buttonText;
  if (hasRichText(asRichField(block.content))) return block.content;
  return undefined;
}
